/** Creates an id in order to use in notifications */
export function getConversationTransferRequestNotificationId(type, csid) {
    return `conversation_transfer_${type}_request_${csid}`;
}
